import { useLocaleStore } from "@/store";
import { defineStore } from "pinia";
import { computed, ref } from "vue";
import http from "../http-common";
import { FeaturedPanel } from "./models/featuredPanel.models";

export const useFeaturedPanelStore = defineStore("featured-panel", () => {
  // State
  const panels = ref({
    loading: false,
    documents: [] as Array<FeaturedPanel>,
  });

  // Getters:
  const isFeaturedPanelsLoading = computed(() => {
    return panels.value.loading;
  });
  const getFeaturedPanels = computed(() => {
    return panels.value.documents;
  });

  // Actions
  const requestFeaturedPanels = async (): Promise<void> => {
    panels.value.loading = true;
    const path = `program-featured-panels?locale=${
      useLocaleStore().getCurrentLocaleCode
    }`;

    return http
      .get(path)
      .then((response) => {
        //console.log("response", response.data);
        if (response.data.feature_panel) {
          response.data.feature_panel.forEach((document: any) => {
            // // Check if the document already exists in the panels array
            const docIndex = panels.value.documents.findIndex(
              (doc: any) => doc._id == document._id
            );
            // If it doesn't exist, push the new document to the array
            if (docIndex === -1) {
              panels.value.documents.push(mapResponseToFeaturedPanel(document));
            } else {
              // If it exists, update the existing document in the array
              panels.value.documents[docIndex] =
                mapResponseToFeaturedPanel(document);
            }
          });
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        panels.value.loading = false;
      });
  };

  const mapResponseToFeaturedPanel = (data: any): FeaturedPanel => {
    return {
      _id: data._id,
      title: data.title,
      icon: data.icon.asset.url,
      description: data.description,
      button_text: data.button_text,
      link: data.link,
    };
  };

  return {
    panels: panels,
    isFeaturedPanelsLoading: isFeaturedPanelsLoading,
    getFeaturedPanels: getFeaturedPanels,
    requestFeaturedPanels: requestFeaturedPanels,
  };
});
